import React from "react";
import { object, bool } from "prop-types";
import get from "lodash/get";

import PublishedAt from "../../atoms/PublishedAt";

import "./storyMetaData.m.css";

const StoryMetaData = ({ story, isPublished = true }) => {
  const showLiveBlog = story["story-template"] === "live-blog";
  const isClosed = get(story, ["metadata", "is-closed"], false);

  return (
    isPublished &&
    (!isClosed && showLiveBlog ? null : (
      <div styleName="story-meta-data" className="story-meta-data">
        <PublishedAt date={story["last-published-at"]} className="published-time" />
      </div>
    ))
  );
};

StoryMetaData.propTypes = {
  story: object.isRequired,
  isPublished: bool,
};

export default StoryMetaData;
